/** Sentinel wartość dla filtra statusu: pokaż wszystkie dokumenty (w tym aneksowane i anulowane) */
export const STATUS_FILTER_ALL = -1;

export interface SalesDocumentFilters {
    nrOffer:string;
    nrOrder:string;
    documentCode:string;
    status:number;
    creationDateFrom: Date;
    creationDateTo: Date;
    validityDateFrom: Date;
    validityDateTo: Date;
    client:string;
    authorUserId:number;
}

export interface SalesDocumentFiltersDTO extends Omit<SalesDocumentFilters, 'creationDateFrom' | 'creationDateTo' | 'validityDateFrom' | 'validityDateTo'>{
    creationDateFrom: string;
    creationDateTo: string;
    validityDateFrom: string;
    validityDateTo: string;
}